export default "__VITE_ASSET__DiPacyS1__"